module.exports = __webpack_public_path__ + "static/openclaw-cb56249e509a252613583133c4012913.webp";